import React, { useEffect, useState } from 'react';
import { Dialog, Grid, IconButton, useMediaQuery, useTheme, withStyles } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Close } from '@material-ui/icons';
import { Toastr, tools } from 'data/common';
import AutoConsoBarChart from '../AutoConsoBarChart';
import { getStatsProductsConsoProd } from '../../../../data/Products/actions';
import Translator from '../../../../../../../../translator';

function ProductStatsModal({ onClose, classes, code, label, product_identifier, homeId, fromDate, ...props }) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [stats, setStats] = useState([{}]);

    useEffect(() => {
        getStatsProducts();
    }, [code, product_identifier, homeId, fromDate]);

    const getStatsProducts = async () => {
        let productCode = code === '0' ? '' : code;
        await props
            .getStatsProductsConsoProd(homeId, fromDate, product_identifier, productCode)
            .then(productStats => {
                setStats(productStats);
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
            });
    };

    return (
        <Dialog open onClose={onClose} maxWidth={false} fullScreen={fullScreen}>
            <Grid container className={classes.container}>
                <Grid className={classes.title} container item xs={11}>
                    {`${label} - ${product_identifier} - ${code}`}
                    <IconButton aria-label="close" style={{ position: 'absolute', right: 18, top: 18 }} onClick={onClose}>
                        <Close fontSize="inherit" />
                    </IconButton>
                </Grid>

                <AutoConsoBarChart filter="hours" data={stats.sort((a, b) => new Date(a.date + ':00') - new Date(b.date + ':00'))} productStats />
            </Grid>
        </Dialog>
    );
}

const styles = theme => ({
    container: {
        width: 600,
        height: 400,
        padding: 18,
    },
    title: {
        color: theme.palette.primary.main,
        textAlign: 'baseline',
        fontSize: 34,
        fontWeight: 400,
    },
});

export default withRouter(
    connect(
        null,
        (dispatch, ownProps) => bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, { getStatsProductsConsoProd }), dispatch),
    )(withStyles(styles, { withTheme: true })(ProductStatsModal)),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/components/modals/ProductStatsModal.js